<script>
import LeadsGrid from '@/views/crm/leads/Grid';

export default {
    name: 'RatingLeadsGrid',
    data() {
        return {
            headerOptions: {
                isUnreadMessagesCountVisible: false,
                isFilterVisible: false,
                isNewButtonVisible: false,
                isGoBackButtonVisible: true,
                isExcelButtonVisible: false
            },
            title: 'Список лидов по выбранному показателю рейтинга',
            filterModel: {
                ids: []
            },
            fieldsNames: {
                ids: 'ид'
            }
        };
    },
    extends: LeadsGrid,
    computed: {
        leadIds() {
            return this.$store.state.analytics.leadIds || [];
        }
    },
    mounted() {
        this.checkLeadIdsProp();
        this.setFilter();
        this.getDataFromServer();
    },
    methods: {
        checkLeadIdsProp() {
            if (!this.leadIds || !this.leadIds.length) {
                this.$router.push({ name: 'analytics-employers-rating' });
            }
        },
        setFilter() {
            this.filterModel.ids = [...this.leadIds];
        },
        loadSettings() {
            //not load settings(override parent method)
        },
        saveSetting() {
            //not save settings(override parent method)
        }
    }
};
</script>
